'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _connectField = require('uniforms/connectField');

var _connectField2 = _interopRequireDefault(_connectField);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListAdd = function ListAdd(_ref) {
    var addIcon = _ref.addIcon,
        className = _ref.className,
        disabled = _ref.disabled,
        parent = _ref.parent,
        value = _ref.value,
        props = (0, _objectWithoutProperties3.default)(_ref, ['addIcon', 'className', 'disabled', 'parent', 'value']);

    var limitNotReached = !disabled && !(parent.maxCount <= parent.value.length);

    return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
            className: (0, _classnames2.default)('label label-default label-pill float-xs-right', className),
            onClick: function onClick() {
                return limitNotReached && parent.onChange(parent.value.concat([value]));
            }
        }, (0, _filterDOMProps2.default)(props)),
        addIcon
    );
};

ListAdd.defaultProps = { addIcon: _react2.default.createElement('i', { className: 'octicon octicon-plus' }) };

exports.default = (0, _connectField2.default)(ListAdd, { includeParent: true, initialValue: false });


//////////////////
// WEBPACK FOOTER
// ./~/uniforms-bootstrap4/ListAddField.js
// module id = 466
// module chunks = 0